  /**
   * @memberof SMART2
   * @ngdoc directive
   * @name Section
   * @description This directive is useful for creating a section.
   * 
   * @attr {String} label
   *    Label to be displayed on section header. If 'is-header' is set to true, label will be displayed on section header.
   * @attr {Boolean} plain
   *    If set to true, section with no style will be generated
   * @attr {Boolean} is-collapsible
   *    If set to true, section will be collapsible
   * @attr {String} header-template
   *    This attribute is useful for creating sections with custom header templates.
   *    'header-template' is expected to be an URL of a template.
   * @attr {Boolean} is-active
   *    If set to false and if 'is-collapsible' is set to true, section will be displayed in collapsed mode. Default value is true.      
   * @attr {Boolean} is-header
   *    If set to true, section-header will be displayed. Default value is true.
   * 
   * @example
   Dynamic:
   Controller:
       $scope.config = {
            "modelData": {
                "firstName": "Sushant"
            }, 
            "formConfig": {
                "sections": [
                    {
                        "isMandatory": true,
                        "rows": [
                            {
                                "properties": [
                                    {
                                        "label": "First name",
                                        "type": "textfield",
                                        "isMandatory": true,
                                        "data": "firstName"
                                    }
                                ]    
                            }
                        ]
                    }
                ]
            }
        };
    Usage:
        <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>
    
   * @example 
   Dynamic: (Section with header)
   Controller:
       $scope.config = {
            "modelData": {
                "firstName": "Sushant"
            }, 
            "formConfig": {
                "sections": [
                    {
                        "label": "Section header",
                        "isHeader": true,
                        "isMandatory": true,
                        "rows": [
                            {
                                "properties": [
                                    {
                                        "label": "First name",
                                        "type": "textfield",
                                        "isMandatory": true,
                                        "data": "firstName"
                                    }
                                ]    
                            }
                        ]
                    }
                ]
            }
        };
    Usage:
        <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>

   * @example 
   Dynamic: (Section with custom header-template)
   Controller:
       $scope.config = {
            "modelData": {
                "firstName": "Sushant"
            }, 
            "formConfig": {
                "sections": [
                    {
                        "headerTemplate": "abc.html",
                        "isMandatory": true,
                        "rows": [
                            {
                                "properties": [
                                    {
                                        "label": "First name",
                                        "type": "textfield",
                                        "isMandatory": true,
                                        "data": "firstName"
                                    }
                                ]    
                            }
                        ]
                    }
                ]
            }
        };
    Usage:
        <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>

   * @example 
   Dynamic: (Section with collapsible header)
   Controller:
       $scope.config = {
            "modelData": {
                "firstName": "Sushant"
            }, 
            "formConfig": {
                "sections": [
                    {
                        "headerTemplate": "abc.html",
                        "isCollapsible": true,
                        "isMandatory": true,
                        "rows": [
                            {
                                "properties": [
                                    {
                                        "label": "First name",
                                        "type": "textfield",
                                        "isMandatory": true,
                                        "data": "firstName"
                                    }
                                ]    
                            }
                        ]
                    }
                ]
            }
        };
    Usage:
        <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>

   * @example
   Static:
   <smart-section>
        Section contents will go here
    </smart-section> 

   * @example
   Static: (Section with header)
   <smart-section label="Section Header" is-header="true">
        Section contents will go here
   </smart-section>

   * @example
   Static: (Section with collpsible header)
   <smart-section is-collapsible="true">
        Section contents will go here
   </smart-section>
        
   * @example
   Static: (Section with header and content place holder)
   <smart-section is-header="true">
        <smart-section-header>
            Section header will go here
        </smart-section-header>
        <smart-section-content>
            Section contents will go here
        </smart-section-content>
    </smart-section>    
   */

(function() {
    'use strict';
    
    var sectionCounter = 0;
    
    angular.module('SMART2').directive('smartSection', ['$timeout', '$parse', function ($timeout, $parse) {
        return {
            restrict: 'E',
            replace: true,
            transclude: {
                'header': '?smartSectionHeader',
                'body': '?smartSectionBody'
            },
            scope: {
                config: '=?',
                model: '=?',
                label: '@',
                isSequential: '@',
                isMandatory: '@',
                isDraggable: '@',
                parentScope: '=?',
                formWidgetId: '@',
                isCollapsible: '@',
                headerTemplate: '@',
                isActive: '=?',
                isHeader: '@',
                plain: '@',
                onClick: '&',
                onHeaderClick: '&',
                revisionMode:'@',
                isSwitchable: '@',
                onClickSwitchable: '&',
                infinite: '@'
            },
            link: function (scope, element, attrs) {
                scope.isSwitchFunc = function () {
                    scope.onClickSwitchable({ "section": scope.config });
                }
               if (attrs.id !== '' || attrs.id !== undefined || attrs.id !== null) {
                    scope.sectionId = attrs.id;
                }
                else {
                    scope.sectionId = 'section-' + sectionCounter;
                    sectionCounter++;
                }

                element.attr('id', scope.sectionId);
                
                var sectionHeaderId = '';
                if(scope.config.id){
                    sectionHeaderId = scope.config.id;        
                    var tmpElementCount = $('#' + sectionHeaderId).length;
                    if(tmpElementCount > 0) {
                        sectionHeaderId = sectionHeaderId + '_' + sectionCounter;
                    }
                } else {
                    sectionHeaderId = 'header_' + sectionCounter;
                    sectionCounter++;
                }
                scope.sectionHeaderId = sectionHeaderId;
		    
                scope.collapsible = scope.$eval(scope.isCollapsible) == true ? true : false;
                scope.active = angular.isUndefined(scope.isActive) || scope.isActive == true ? true : false;
                scope.header = scope.$eval(scope.isHeader) ? true : false;

                if(!scope.collapsible) {
                    scope.active = true;
                }
                else {
                    scope.header = true;
                }

                scope.isCollapsed = scope.active;

                if(!scope.headerTemplate) {
                    scope.headerTemplate = '';
                }
                
				/*
				 * Update optional field item
				 */
                var onRowsConfig = scope.$watch('config.rows', function (newConfig) {
                    if(newConfig) {
                        var rowsLen = scope.config.rows.length;
                        for (var j = 0; j < rowsLen; j++) {
                            var propLength = scope.config.rows[j].properties.length;
                            for (var k = 0; k < propLength; k++) {
                                var tData = scope.config.rows[j].properties[k];
                                if (!tData.isMandatory) {
                                    updateOptionalField(tData);
								}
							}
						}
                    }
                }, true);
                    
                var updateOptionalField = function (item) {
                    var optFieldLen = scope.config.optionalFields.length;
                    for (var i = 0; i < optFieldLen; i++) {
                        var tData = scope.config.optionalFields[i];
                        if (item.label == tData.label) {
                            tData.visible = item.isVisible;
							return;
						}
					}
				};


                /*
                 * Get row's visible properties length
                 */
                var getVisiblePropertiesLength = function (rowIndex) {
                    var visiblePropertiesLength = 0,
                        rowsPropLen = scope.config.rows[rowIndex].properties.length;
                    for (var i = 0; i < rowsPropLen; i++) {
                        var tData = scope.config.rows[rowIndex].properties[i];
                        if (tData.isVisible && !tData.isHidden) {
                            visiblePropertiesLength++;
                        }
                    }
                    return visiblePropertiesLength;
                };


                scope.onOptionalFieldClick = function (isLabelClicked, item) {
                    if (isLabelClicked && item.isVisible) {
                        return;
                    }

                    /*
                     *  If row's visible properties length is 0
                     *  then splice the row and push it at the end of section
                     */
                    var tmpRow = scope.config.rows[item.rowIndex],
                        tmpPropIndxData = tmpRow.properties[item.propertyIndex];
                    if (!scope.$eval(scope.isSequential) && getVisiblePropertiesLength(item.rowIndex) == 0) {
                        scope.config.rows.splice(item.rowIndex, 1);
                        scope.config.rows.push(tmpRow);
                        item.rowIndex = scope.config.rows.length - 1;
                    }

                    // tmpPropIndxData.isVisible = !tmpPropIndxData.isVisible;

                    /*
                     *  scope.isSequential is set to 'true', form-widget-property would be added 
                     *  where it is positioned in the JSON structure else 
                     *  form-widget-property would be added at the end of row
                     */
                    if (!scope.$eval(scope.isSequential) && tmpPropIndxData.isVisible) {
                        //var tmpProperty = scope.config.rows[item.rowIndex].properties[item.propertyIndex];
                        tmpRow.properties.splice(item.propertyIndex, 1);
                        tmpRow.properties.push(tmpPropIndxData);
                        var rowsPropLength = scope.config.rows[item.rowIndex].properties.length;
                        for (var i = 0; i < rowsPropLength; i++) {
                            var optLength = scope.config.optionalFields.length;
                            for (var j = 0; j < optLength; j++) {
                                if (tmpRow.properties[i].label == scope.config.optionalFields[j].label) {
                                    scope.config.optionalFields[j].propertyIndex = i;
                                }
                            }
                        }
                    }
                    item.visible = !item.visible;
                    //  Expand the section
                    if (item.visible) {
                        var clearMe = setTimeout(function () {
                            expandSection();
                            clearTimeout(clearMe);
                            clearMe = null;
                        }, 250);
                    }
                };

                var isActiveTriggered = false;

                /*
                 * Expand section if isActive is set to true
                 */
                var onIsActive = scope.$watch('isActive', function (newValue) {
                	if (angular.isDefined(newValue) && newValue) {
                		isActiveTriggered = true;
                    	expandSection();
                    	scope.isActive = false;
                    }
                });


                /*
                 * On optional field click listener
                 */
                var onOptionalFieldClick = scope.$on('optionalFieldClick', function (event, args) {
                    try {
                        if (args.item.sectionKey === scope.config.key) {
                            scope.onOptionalFieldClick(args.isLabelClicked, args.item);
                        }
                    }
                    catch(e) {}
                });


                /*
                 *  Expand section
                 */
                var expandSection = function () {
                    var collapsibleHdr = element.find('.collapsible-header');
                    if (!collapsibleHdr.hasClass('active')) {
                        collapsibleHdr.trigger('click');
                    }
                    else if (!collapsibleHdr.hasClass('active')) {
                        collapsibleHdr.trigger('click');
                    }
                };

                var isClicked = false

               var clrTimeout = setTimeout(function () {
                    element.find('.collapsible-header').click(function () {
                    	var ele = this;

                        scope.$evalAsync(function () {
                        	if (isClicked && !isActiveTriggered)
                        		return;
                        	
                        	isClicked = true;
                            scope.isCollapsed = angular.element(ele).hasClass('active');
                            scope.active = scope.isCollapsed;
                            scope.onHeaderClick();
                            scope.onClick();
                        	    isClicked = false;
                        	isActiveTriggered = false;
                            clearTimeout(clrTimeout);
                            clrTimeout = null;
                        });
                    });
                });

                
                /*
                 *  Expand section on header focus
                 */
                scope.onSectionHeaderFocus = function (e) {
                    if ($(e.target).hasClass('section-header-focuser') && !scope.active) {
                        scope.config.isContentLoaded = true;
                        scope.active = true;
                        //scope.isCollapsed = true;
                        expandSection();
                    }
                };
                

                /*
                 *  Remove all listeners on scope destroy
                 */
                scope.$on('$destroy', function () {
                    onRowsConfig();
                    onIsActive();
                    onOptionalFieldClick();
                    element.find('.collapsible-header').off('click');
                });
            },
            templateUrl: 'shared/directives/uiElements/smartSection/smartSectionTemplate.html'
        };
    }]);
    
    var angular2BootstrapTimeout;

    angular.module('SMART2').directive('smartSectionItemRenderer', ['$compile', 'formWidgetUtils', '$translate', '$templateCache', '$timeout', function ($compile, formWidgetUtils, $translate, $templateCache, $timeout) {
        return {
            restrict: 'E',
            replace: false,
            link: function (scope, element, attrs) {
                var html = "", commonAttributes;

                if (scope.section) {
                    if (scope.section.controller) {
                        //  Creating dataModel variable so that child controller can access it using $scope.formDataModel
                        scope.formDataModel = scope.$parent.$parent.$parent.modelData;

                        html += '<div ng-controller="' + scope.section.controller + '">';
                    }

                    if (scope.section.isLazyLoadEnabled) {
                        scope.section.isActive = false;
                    }

                    //scope.section.isContentLoaded = !angular.copy(scope.section.isLazyLoadEnabled);

                    //  Section's primary attribute and can be optional
                    scope.extendedSectionConfig = angular.extend({
                        isMandatory: false,
                        isCollapsible: true,
                        isDraggable: false,
                        isHeader: true,
                        isActive: true,
                        isHidden: true,
                        isSwitchable: false,
                        isLazyLoadEnabled: false,
                        infinite:false,
                        headerTemplate: ''
                    }, scope.section);

                    scope.section.isLoading = true;
                    scope.section.isContentLoaded = false; // !angular.copy(scope.section.isLazyLoadEnabled);

                    var cancelTOut = $timeout(function () {
                        scope.section.isLoading = false;
                        scope.section.isContentLoaded = !angular.copy(scope.section.isLazyLoadEnabled);
                        $timeout.cancel(cancelTOut);
                        cancelTOut = null;
                    }, scope.$index * 500);

                    //  Since smart-component-injector changes the scope hierarchy, change the parent scope ref accordingly
                    scope.parentScopeRef = element.closest('smart-component-injector').length > 0 ? element.closest('smart-component-injector').scope() : scope.$parent.$parent.$parent.$parent;

                    commonAttributes = ' label="{{section.label | translate}}" config="section" model="modelData" plain="{{section.plain}}" is-sequential="{{isSequential}}" ' + formWidgetUtils.getAttributesMapping('primary', scope.extendedSectionConfig, scope, true) + ' parent-scope="' + (scope.section.controller ? '$parent.$$childTail' : 'parentScopeRef') + '" form-widget-id="{{formWidgetId}}" ';

                    commonAttributes += "revision-mode=" + ((!scope.revisionMode || scope.revisionMode == "false") ? "'false'" : "'true'"); // added for revision mode
                    html += '<smart-section id=' + scope.formWidgetId + '-section-' + scope.$index + ' ' + commonAttributes + formWidgetUtils.mapEvents([
                        { type: 'on-click', listener: 'onSectionClick(section)' },
                        // { type: 'on-header-click', listener: formWidgetUtils.generateFunctionWithParams(scope.section.onHeaderClick, '$parent.$parent.$parent.$parent', true) },
                        { type: 'on-header-click', listener: 'onSectionHeaderClick(section)' },
                          { type: 'on-click-switchable', listener: formWidgetUtils.generateFunctionWithParams(scope.section.onClickSwitchable, '$parent.$parent.$parent.$parent', true) }
                    ]) + '></smart-section>';

                    if (scope.section.controller) {
                        html += '</div>';
                    }
                }
                else {
                    var ngModelMapping, optionsMapping;


                    if (scope.property.type == 'subsection') {
                        ngModelMapping = 'model-data="model.' + scope.property.data + '"' + 'form-model="model"';
                    }
                    else if (scope.property.type == 'dropdown') {
                        ngModelMapping = 'ng-model="model.' + scope.property.data + '"';
                        if (angular.isDefined(scope.property.optionsData))
                            optionsMapping = 'options="model.' + scope.property.optionsData + '"';
                    }
                    else {
                        ngModelMapping = 'ng-model="model.' + scope.property.data + '"';

                        try {
                            if (scope.property.attributes.ngModelOptions.getterSetter) {
                                ngModelMapping = 'ng-model="parentScope.' + scope.property.data + '"';
                            }
                        }
                        catch (e) { }
                    }

                    var areaType = false;
                    if (typeof scope.property.attributes != 'undefined' && typeof scope.property.attributes.type != 'undefined' && scope.property.attributes.type == 'area')
                    	areaType = true;

                    commonAttributes = ' class="' + formWidgetUtils.getColspanClass(scope.property.colspan) + (scope.property.type != 'subsection' ? (scope.property.type == 'textfield' && areaType) ? ' area-height-manager' : ' line-height-manager' : '') + '" label="{{property.label | translate}}" focus="' + (typeof scope.property.focus == 'string' ? 'parentScope.' + scope.property.focus : 'property.focus') + '" validate="' + (typeof scope.property.validate == 'string' ? 'parentScope.' + scope.property.validate : 'property.validate') + '" ' + ngModelMapping + ' ' + optionsMapping + ' ' + formWidgetUtils.getAttributesMapping('primary', scope.property, scope) + ' parent-element="{{formWidgetId}}" ' + formWidgetUtils.getAttributesMapping('secondary', scope.property.attributes, scope);
                    if (scope.property.showInfo) {
                        commonAttributes += 'showinfo ="' + $translate.instant(scope.property.showInfo) + '"';
                    }
		    if(scope.property.id){
             		commonAttributes += 'id="' + scope.property.id + '"';
		    }
           
                    switch (scope.property.type) {
                        case 'textfield':
                            html = '<smart-textfield ' + commonAttributes + formWidgetUtils.mapEvents([
                                { type: 'on-change', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onChange, 'parentScope') },
                                { type: 'on-focus', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onFocus, 'parentScope') },
                                { type: 'on-blur', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onBlur, 'parentScope') },
                                { type: 'on-key-up', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onKeyUp, 'parentScope') },
                                { type: 'on-key-down', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onKeyDown, 'parentScope') },
                                { type: 'on-key-press', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onKeyPress, 'parentScope') },
                                { type: 'on-enter', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onEnter, 'parentScope') },
                                { type: 'on-select', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onSelect, 'parentScope') },
                                { type: 'on-date-change', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onDateChange, 'parentScope') },
                                { type: 'on-destroy', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onDestroy, 'parentScope') }
                            ]) + '></smart-textfield>';
                            break;

                        case 'dropdown':
                        case 'select':
                            html = '<smart-select validate="property.validate" ' + commonAttributes + formWidgetUtils.mapEvents([
                                { type: 'on-change', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onChange, 'parentScope') },
                                { type: 'on-destroy', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onDestroy, 'parentScope') }
                            ]) + '></smart-select>';
                            break;

                        case 'radio':
                            html = '<smart-radio gap="true"' + commonAttributes + formWidgetUtils.mapEvents([
                                { type: 'on-change', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onChange, 'parentScope') },
                                { type: 'on-destroy', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onDestroy, 'parentScope') }
                            ]) + '></smart-radio>';
                            break;

                        case 'checkbox':
                            html = '<smart-checkbox fill="true" min-height="50px" ' + commonAttributes + formWidgetUtils.mapEvents([
                                { type: 'on-change', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onChange, 'parentScope') },
                                { type: 'on-destroy', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onDestroy, 'parentScope') }
                            ]) + '></smart-checkbox>';
                            break;

                        case 'switch':
                            html = '<smart-switch ' + commonAttributes + formWidgetUtils.mapEvents([
                                { type: 'on-change', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onChange, 'parentScope') },
                                { type: 'on-destroy', listener: formWidgetUtils.generateFunctionWithParams(scope.property.onDestroy, 'parentScope') }
                            ]) + '></smart-switch>';
                            break;

                        case 'subsection':
                            /*
                             *  Check if subsection is angular2 enabled i.e. if sub-section should boostrap Angular2 app
                             */
                            if (scope.property.isAngular2Enabled) {
                                html = $templateCache.get(scope.property.templateUrl);
                            }
                            else {
                                /*
                                 *  Convert onLoad function in a way that function name should be converted to subsection controller function
                                 *  and its parameteres should be converted into parent controller's variables
                                 */
                                var onLoadFunction = '';
                                if (scope.property.onLoad == '' || scope.property.onLoad == undefined || scope.property.onLoad == null) {
                                    scope.property.onLoad = '';
                                }
                                if (scope.property.onLoad != '') {
                                    onLoadFunction = formWidgetUtils.generateFunctionWithParams(scope.property.onLoad, 'parentScope');
                                    onLoadFunction = onLoadFunction.replace('parentScope.' + scope.property.onLoad.split('(')[0], '$$$childHead.' + scope.property.onLoad.split('(')[0]);
                                    onLoadFunction = onLoadFunction.replace(',property', '');
                                }
                                html = '<smart-subsection class="' + formWidgetUtils.getColspanClass(scope.property.colspan) + ' padding0" controller="{{property.controller}}" init="{{property.init}}" template-url="{{property.templateUrl}}" parent-scope="parentScope" widget-scope="parentScope.$parent.$parent.$parent"' + commonAttributes + formWidgetUtils.mapEvents([
                                    { type: 'on-load', listener: onLoadFunction }
                                ]) + '></smart-subsection>';
                            }
                            break;

                        case 'revision':
                            var revisionAttrs = [
                                "class = '" + formWidgetUtils.getColspanClass(scope.property.colspan) + "'",
                                "label='{{::property.label | translate}}'",
                                "old-data='::property.attributes.oldData'",
                                "new-data='::property.attributes.newData' ng-if='::property.label'"
                            ].join(" ");
                            html = '<smart-revision '+ revisionAttrs +'></smart-revision>';
                            break;
                    }
                }
                element.html(html);

                if (scope.property && scope.property.isAngular2Enabled) {
                    if (scope.property.isAngular2AppBootstrapped) {
                        if (!window.angular2App.app._destroyed) {
                            window.angular2App.app.destroy();
                        }
                        window.angular2App.platformBrowserDynamic.bootstrapModule(window.angular2App.moduleRef);
                    }
                    else {
                        scope.property.isAngular2AppBootstrapped = true;
                    }
                }
                else {
                    $compile(element.contents())(scope);
                }
            }
        };
    }]);
})();    
